<p class="message"
  [ngClass]="{
    'message_sm': type === 'sm'
  }"
  [style.textAlign]="textAlign"
>{{ message }}</p>
